import { z } from "zod";

export const schema = z.object({
	id_instagram: z.number().int("Campo id_instagram é obrigatorio"),
	cod_conta: z.string().optional(),
	descricao: z.string().min(1, "Campo Usuário é obrigatório"),
	token_instagram: z.string().optional(),
});

export const schemaDefaultValues = {
	id_instagram: 0,
	cod_conta: "",
	descricao: "",
	token_instagram: "",
};
